import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import PublicSharePage from './components/share/PublicSharePage';
import ChurchApp from './components/ChurchApp';
import SplashScreen from './components/SplashScreen';
import KakaoCallback from './components/auth/KakaoCallback';
import ForcePasswordChange from './components/auth/ForcePasswordChange';
import AdminDashboardPage from './components/AdminDashboardPage';
import AdminLogin from './components/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuthStore } from './store/authStore';

function App() {
  // 스플래시 화면 임시 비활성화 (디버깅)
  const [showSplash, setShowSplash] = useState(false);
  const { setLoading } = useAuthStore();

  useEffect(() => {
    // 앱 초기화 시 토큰 확인
    const checkAuth = () => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        // TODO: 토큰 유효성 검사
        setLoading(false);
      } else {
        setLoading(false);
      }
    };

    checkAuth();
  }, [setLoading]);


  const handleSplashFinish = () => {
    const now = new Date();
    const today = now.toDateString();
    const currentHour = now.getHours();
    const splashData = localStorage.getItem('splashData');
    
    let newCount = 1;
    
    if (splashData) {
      try {
        const { date, hour, count } = JSON.parse(splashData);
        
        if (date === today && hour === currentHour) {
          // 같은 날짜, 같은 시간이면 카운트 증가
          newCount = count + 1;
        }
        // 다른 날짜나 다른 시간이면 newCount = 1 (이미 설정됨)
      } catch (error) {
        // 잘못된 데이터면 newCount = 1
      }
    }
    
    // 새로운 스플래시 데이터 저장
    localStorage.setItem('splashData', JSON.stringify({
      date: today,
      hour: currentHour,
      count: newCount
    }));
    
    console.log(`📱 스플래시 화면 표시 완료 (${newCount}/3회) - ${today} ${currentHour}시`);
    
    setShowSplash(false);
  };

  if (showSplash) {
    console.log('🎬 스플래시 화면 표시 중...');
    return <SplashScreen onFinish={handleSplashFinish} />;
  }

  console.log('✅ 메인 앱 렌더링');
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/auth/kakao/callback" element={<KakaoCallback />} />
        <Route
          path="/force-password-change"
          element={
            <ProtectedRoute requireAuth={true}>
              <ForcePasswordChange />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/admin-login" 
          element={
            <AdminLoginWrapper />
          } 
        />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute requireAuth={true} requireAdmin={true}>
              <AdminDashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admindash" 
          element={
            <ProtectedRoute requireAuth={true} requireAdmin={true}>
              <AdminDashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/" 
          element={
            <ProtectedRoute requireAuth={false}>
              <ChurchApp />
            </ProtectedRoute>
          } 
        />
        <Route path="/s/:id" element={<PublicSharePage />} />
      </Routes>
    </Router>
  );
}

// AdminLogin 래퍼 (setAuth는 AdminLogin에서 수행, 여기서는 이동만)
function AdminLoginWrapper() {
  const navigate = useNavigate();

  const handleLoginSuccess = (_user?: any, _accessToken?: string, _refreshToken?: string) => {
    console.log('✅ 관리자 로그인 성공, 어드민 페이지로 이동');
    navigate('/admin');
  };

  return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
}

export default App;
